<template>
  <div class="mc-videohistory-stream__state mc-videohistory-stream__state--end">
    <div class="wrapper-content">
      <p>{{ $t('trackVideo.videoEnded') }}</p>
      <div class="wrapper-action">
        <b-button size="sm" variant="outline-primary" class="repeat" @click="$emit('repeat')">
          <i class="mc-fa icon-outline_refresh"></i> {{ $t('trackVideo.repeatVideo') }}
        </b-button>
        <b-button variant="primary" size="sm" class="next" @click="$emit('next')">
          <i class="mc-fa icon-outline_rewind-right"></i> {{ $t('trackVideo.nextVideo') }}
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EndState',
  emits: ['repeat', 'next'],
}
</script>
